import Drawer from "@mui/material/Drawer";
import styled from "styled-components";

import AdminSessionBar from "@pages/AdminDashboard/AdminSessionBar";
import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";

import { AdminNavigationList } from "./AdminNavigationList";
import { AdminTag } from "./AdminTag";
import { ShellIconButton } from "./ShellIconButton";

const { color, shadow, typeScale } = adminTokens;
const [, spaceSm, spaceMd] = adminTokens.spacing;
// The design's drawer: 312px wide, padded 16px above (below the phone's status bar),
// 12px at each side and 36px below; the brand in Medium 18 (SHELL-R34, SHELL-R35).
const drawerWidth = 312;
const drawerPaddingTop = 16;
const drawerPaddingX = 12;
const drawerPaddingBottom = 36;
const brandFontSize = "18px";
const closeIconSize = 20;

const drawerPaperStyle = {
  boxSizing: "border-box",
  width: drawerWidth,
  padding: `${drawerPaddingTop}px ${drawerPaddingX}px ${drawerPaddingBottom}px`,
  backgroundColor: color.surface,
  boxShadow: shadow.raised,
  color: color.navy,
} as const;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${spaceSm}px;
  padding: 0 0 ${spaceMd + 4}px ${drawerPaddingX}px;
`;

const BrandName = styled.span`
  font-family: ${typeScale.labelValue.fontFamily};
  font-size: ${brandFontSize};
  letter-spacing: -0.01em;
`;

const Spacer = styled.div`
  flex: 1;
`;

interface AdminNavigationDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

// The phone's navigation: a drawer over a scrim with the sidebar's brand, navigation
// and session controls (SHELL-R33…R41). The modal keeps keyboard focus inside it,
// closes on Escape or the scrim, and returns focus to the Menu Button.
export const AdminNavigationDrawer = ({ isOpen, onClose }: AdminNavigationDrawerProps) => (
  <Drawer
    anchor="left"
    open={isOpen}
    onClose={onClose}
    PaperProps={{
      role: "dialog",
      "aria-modal": true,
      "aria-label": "Admin navigation",
      elevation: 0,
      sx: drawerPaperStyle,
    }}
    BackdropProps={{ sx: { backgroundColor: color.scrim } }}
  >
    <Header>
      <BrandName>Runway Health</BrandName>
      <AdminTag>Admin</AdminTag>
      <Spacer />
      <ShellIconButton label="Close menu" onClick={onClose}>
        <svg
          aria-hidden="true"
          width={closeIconSize}
          height={closeIconSize}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        >
          <path d="M6 6l12 12M18 6 6 18" />
        </svg>
      </ShellIconButton>
    </Header>
    <AdminNavigationList placement="drawer" onNavigate={onClose} />
    <Spacer />
    <AdminSessionBar />
  </Drawer>
);
